import { useEffect, useState } from "react";
import { checkSlugAvailability } from "@/features/cards/api/cardsApi";
import { validateSlug } from "@/features/cards/slug";

// Debounced availability check. States: idle | invalid | current | checking | available | taken | error.
export function useSlugAvailability(slug, currentSlug) {
  const [result, setResult] = useState({ state: "idle", message: null });

  useEffect(() => {
    if (slug == null) return undefined;
    const invalid = validateSlug(slug);
    if (invalid) {
      setResult({ state: "invalid", message: invalid });
      return undefined;
    }
    if (slug === currentSlug) {
      setResult({ state: "current", message: "This is your card's current link." });
      return undefined;
    }
    let active = true;
    setResult({ state: "checking", message: "Checking availability…" });
    const timer = setTimeout(async () => {
      try {
        const verdict = await checkSlugAvailability(slug);
        if (!active) return;
        if (verdict === "available") setResult({ state: "available", message: "This link is available." });
        else if (verdict === "taken") setResult({ state: "taken", message: "That link is already taken. Try another." });
        else setResult({ state: "error", message: "We couldn't confirm this link. We'll check again when you save." });
      } catch {
        if (active) setResult({ state: "error", message: "We couldn't confirm this link. We'll check again when you save." });
      }
    }, 450);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [slug, currentSlug]);

  return result;
}
